import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from 'js-cookie';

export const servicesApi = createApi({
  reducerPath: "services",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
      const { auth } = getState();
      const token = auth.user.token
      headers.set('Authorization', `Bearer ${token}`);
      headers.set('Content-Type', `application/json;charset=UTF-8`);
      return headers;
    },
  }),
  tagTypes: ["services/products", "serviceTypes", "services/brands", 'services/icons', 'products'],
  endpoints: (builder) => ({
    services: builder.query({
      query: (data) => {
          return {
              url: "/Auth/getServiceList",
              method: "GET",
              params: data
          }
      },
      providesTags: ["services"],
    }),
    singleServiceCategory: builder.query({
      query: (data) => {
          return {
            url: "/Auth/getServiceList",
            method: "GET",
            params: data
          }
      },
      providesTags: ["services"],
    }),
    createServiceCategory: builder.mutation({
      query: (data) => {
        return {
          url: "/Auth/CreateServiceCategory",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["services"],
    }),
    updateServiceCategory: builder.mutation({
      query: (data) => {
        return {
          url: "/Auth/updateServiceCategory",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["services"],
    }),
    changeServiceCategoryStatus: builder.mutation({
      query: (data) => {
        return {
          url: `/Service/UpdateServiceCategoryStatus`,
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["services"],
    }),
    deleteServiceCategoryCat: builder.mutation({
        query: (data) => {
          return {
            url: `/Service/DeleteServiceCategory?keyID=${data}`,
            method: "POST",
          };
        },
        invalidatesTags: ["services"],
    }),
    
    // Service/Products Pages
    serviceProducts: builder.query({
      query: (data) => {
          return {
            url: "/Service/GetProductOrServiceDetails",
            method: "GET",
            params: data
          }
      },
      providesTags: ["services/products"],
    }),
    addOnProducts: builder.query({
      query: (data) => {
          return {
            url: "/Service/GetAddOnDetails",
            method: "GET",
            params: data
          }
      },
      providesTags: ["services/products"],
    }),
    createService: builder.mutation({
      query: (data) => {
        return {
          url: "/Service/createProductOrService",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["services/products", "requisitions"],
    }),
    UpdateProductOrServie: builder.mutation({
      query: (data) => {
        return {
          url: "/Service/UpdateProductOrService",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["services/products"],
    }),
    changeServiceProductStatus: builder.mutation({
      query: (data) => {
        return {
          url: `/Service/UpdateManageServiceProductStatus`,
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["services/products"],
    }),
    deleteServiceProduct: builder.mutation({
        query: (data) => {
          return {
            url: `/Service/DeleteService?keyID=${data}`,
            method: "POST",
          };
        },
        invalidatesTags: ["services/products"],
    }),
    deleteServiceProductChild: builder.mutation({
      query: (data) => {
        return {
          url: `/Service/${data.type == 1 ? 'DeleteProductChild': 'DeleteServiceChild'}?keyID=${data.id}`,
          method: "POST",
        };
      },
      invalidatesTags: ["services/products"],
    }),

    // BRANDS
    brands: builder.query({
      query: (data) => {
          return {
            url: "/Service/GetBrands",
            method: "GET",
            params: data
          }
      },
      providesTags: ["services/brands"],
    }),
    singleBrand: builder.query({
      query: (data) => {
          return {
            url: "/Service/GetBrands",
            method: "GET",
            params: data
          }
      },
      providesTags: ["services/brands"],
    }),
    UpdateBrand: builder.mutation({
      query: (data) => {
        return {
          url: "/Service/UpdateBrand",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["services/brands"],
    }),
    createBrand: builder.mutation({
      query: (data) => {
        return {
          url: "/Service/CreateBrand",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["services/brands"],
    }),
    changeServiceBrandStatus: builder.mutation({
      query: (data) => {
        return {
          url: `/Service/UpdateBrandStatus`,
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["services/brands"],
    }),
    deleteServiceBrand: builder.mutation({
        query: (data) => {
          return {
            url: `/Service/DeleteBrand?keyID=${data}`,
            method: "POST",
          };
        },
        invalidatesTags: ["services/brands"],
    }),

    
    icons: builder.query({
      query: (data) => {
          return {
            url: "/Service/GetServiceIcon",
            method: "GET",
            params: data
          }
      },
      providesTags: ["services/icons"],
    }),
    CreateServiceType: builder.mutation({
      query: (data) => {
        return {
          url: "/Service/CreateServiceType",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["serviceTypes", "products"],
    }),

   
    UpdateServiceType: builder.mutation({
      query: (data) => {
        return {
          url: "/Service/UpdateServiceType",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["products", "serviceTypes"],
    }),
    changeServiceCategoryStatus: builder.mutation({
      query: (data) => {
        return {
          url: `/Service/UpdateServiceProductStatus`,
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["products"],
    }),
    deleteServiceCategory: builder.mutation({
        query: (data) => {
          return {
            url: `/Service/DeleteServiceProduct?keyID=${data}`,
            method: "POST",
          };
        },
        invalidatesTags: ["products"],
    }),

    // Services/Products Type
    productType: builder.query({
      query: (data) => {
          return {
              url: "/Service/GetServiceTypes",
              method: "GET",
              params: data
          }
      },
      providesTags: ["productTypes", "serviceTypes", "products"],
    }),
    singleProductType: builder.query({
      query: (data) => {
          return {
              url: "/Service/GetServiceTypes",
              method: "GET",
              params: data
          }
      },
      providesTags: ["productTypes"],
    }),
    statusChangeServiceType: builder.mutation({
      query: (data) => {
        return {
          url: `/Service/UpdateServiceProductStatus`,
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["productTypes"],
    }),
     ChangeServiceType: builder.mutation({
      query: (data) => {
        return {
          url: `/Service/UpdateServiceType`,
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["productTypes"],
    }),
    deleteServiceType: builder.mutation({
        query: (data) => {
          return {
            url: `/Service/DeleteServiceProduct?keyID=${data}`,
            method: "POST",
          };
        },
        invalidatesTags: ["productTypes"],
    }),
    
    createStockLog: builder.mutation({
      query: (data) => {
        return {
          url:  "/Service/createStockLog",
          method: "POST",
          body: data
        };
      },
      invalidatesTags: ["services/products"],
    }),

    
  }),
});

export const { 
  useServicesQuery,
  useSingleServiceCategoryQuery,
  useCreateServiceCategoryMutation,
  useUpdateServiceCategoryMutation,
  useChangeServiceCategoryStatusMutation,
  useDeleteServiceCategoryMutation,
  useServiceProductsQuery,
  useAddOnProductsQuery,
  useStatusChangeServiceTypeMutation,
  useChangeServiceTypeMutation,
  useDeleteServiceTypeMutation,
  useDeleteServiceCategoryCatMutation,
  useBrandsQuery, 
  useSingleBrandQuery,
  useUpdateBrandMutation,
  useCreateBrandMutation,
  useChangeServiceBrandStatusMutation,
  useDeleteServiceBrandMutation, 
  useCreateServiceMutation, 
  useIconsQuery,
  useUpdateProductOrServieMutation,
  useDeleteServiceProductMutation,
  useDeleteServiceProductChildMutation,
  useChangeServiceProductStatusMutation,
  useCreateServiceTypeMutation,
  useProductTypeQuery,
  useSingleProductTypeQuery,
  useUpdateServiceTypeMutation,
  useCreateStockLogMutation,

} = servicesApi;
